import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { useSeo } from "../hooks/useSeo";
import { CtaLink } from "../components/ui/CtaLink";
const SUGGESTIONS = [{
  label: "Services",
  href: "/services"
}, {
  label: "Pricing",
  href: "/pricing"
}, {
  label: "Live Demo",
  href: "/demo"
}, {
  label: "Contact",
  href: "/contact"
}];
export function NotFound() {
  useSeo({
    title: "Page not found",
    description: "The page you're looking for doesn't exist.",
    path: window.location.pathname,
    noindex: true
  });
  return <section className="relative overflow-hidden" data-id="element-762" data-mp="1f0snvmkd72te">
      <div className="grid-lines pointer-events-none absolute inset-0" aria-hidden data-id="element-763" data-mp="1juwvm81gfevj" />
      <div className="blue-glow pointer-events-none absolute inset-0" aria-hidden data-id="element-764" data-mp="1nvp42z2i5fqr" />
      <div className="shell relative flex min-h-[calc(100vh-84px)] flex-col justify-center py-20" data-id="element-765" data-mp="1sus7yg6qxfx5">
        <p className="font-display text-[clamp(6rem,4rem+14vw,22rem)] font-semibold leading-none tracking-tighter text-accent" data-id="element-766" data-mp="1xtd9qk1nc7np">404</p>
        <h1 className="t-h2 mt-4 max-w-[16ch]" data-id="element-767" data-mp="1nwn574z2b95s">This page doesn't exist.</h1>
        <p className="t-lead mt-5 max-w-[46ch] text-muted" data-id="element-768" data-mp="1iwhmiearswzu">The link may be broken or the page may have moved. Try one of these instead:</p>
        <div className="mt-10 flex flex-wrap items-center gap-3" data-id="element-769" data-mp="1evflpt17gcvr">
          <CtaLink to="/" track="404_home" size="lg" data-id="element-770" data-mp="19wugff73j30g">Back to home <ArrowRightIcon className="h-4 w-4" data-id="element-771" data-mp="19yfg1j89pc56" /></CtaLink>
          {SUGGESTIONS.map(s => <Link key={s.href} to={s.href} className="inline-flex min-h-[52px] items-center rounded-full border border-line-strong px-6 text-fg-2 hover:text-fg" data-id="element-772" data-mp="26o69df4tot9e">{s.label}</Link>)}
        </div>
      </div>
    </section>;
}